<template>
  
  <div class="container">
  
    <Cabecera></Cabecera>
    <b-breadcrumb>
    <b-breadcrumb-item href="#"><router-link to="/">Inicio</router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/menuinicial">Inicio Usuario </router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/Decomisos">Registro de decomisos por inspección</router-link></b-breadcrumb-item>
    
  </b-breadcrumb>
  <div>
  <Menu/>
    
  <b-card>
    
   <br>

        
          <span class="card-title">Registro de decomisos</span>
          <form id="formPeso" autocomplete="off" @submit.prevent="editar" enctype="multipart/form-data">
            <input type="text" placeholder="Unidad" :value=unidad required disabled>
             <input type="date" name="fecharegistro" id="fecharegistro" placeholder="Fecha" v-on:click=usuario() required>
             <b-form-select v-model="selected2" class="mb-3" required>
                <template v-slot:first>
        <b-form-select-option :value="null" disabled  >-- Selecciona especie --</b-form-select-option>
      </template>
      <b-form-select-option value="Bovino">Bovino</b-form-select-option>
      <b-form-select-option value="Porcino">Porcino</b-form-select-option>
     
    </b-form-select>
       <div class="file-field input-field">
                <div class="btn">
                <span>Evidencia</span>
                <input type="file" name="evidencia">
                </div>
                <div class="file-path-wrapper">
                <input class="file-path validate" type="text">
                </div>
            </div>      

   

            
            <b-form-select v-model="selected" class="mb-3" :options="options" required >
                <template v-slot:first>
        <b-form-select-option :value="null" disabled  >-- Selecciona una sección u órgano --</b-form-select-option>
      </template>
    </b-form-select>
    <input type="number" id="folio" name="folio" placeholder="Folio Papeleta"  pattern="[0-9]+([\.,][0-9]+)?" step="1" required v-on:blur=getStringDatos()>
            <input type="text" name="serie" id="serie" placeholder="Serie">
            <input type="number" v-model="value" name="canal" id="canal" placeholder="Número de canal"  pattern=".{3,10}" required v-on:click=getStringDatos()>
            
    <input type="text" name="otro" id="otro" placeholder="Otro padecimiento" v-on:click=getStringDatos()>
            <input type="hidden" name="unidadForma" id="unidadForma" :value=unidad> 
             <input type="hidden" name="organoForma" id="organoForma" :value=selectedOrgano> 
             <input type="hidden" name="padecimientoForma" id="padecimientoForma" :value=selectedPadecimiento> 
             <input type="hidden" name="usuarioForma" id="usuarioForma" :value=usuariolocal>
             <input type="hidden" name="especieForma" id="especieForma" :value=selected2>
             
             <input type="hidden" name="idForma" id="idForma" :value=idActual>
            
<div class="card-action">

                        <input type="submit" value="Registrar" class="btn btn-outline-success" required v-on:click=getStringDatos()>
                           
        </div>
            </form>
       
    <b-card-body class="text-center">
      <b-card-title>Pantalla de inicio</b-card-title>

      <b-card-text>
       <div>
    <h5>Listado del día <input width="4" type="date" name="fechadia" id="fechadia" placeholder="Fecha" v-on:click=ajax() >
<p id="datetime"></p>
    </h5>
   <vue-good-table
   :columns="columns"
     :rows="rows"
     @on-cell-click="onCellClick"
     
     :pagination-options="{
       enabled:true,
      
       mode:'remote',
       perPage:350,
       position:'top',
       perPageDropdown:[10,50,100],
       nextLabel:'Siguiente',
       PrevLabel:'Anterior',
       rowsPerPageLabel:'Filas por página',
       ofLabel:'de'
     }"
     :search-options="{
       enabled:true,
       trigger:'enter',
       placeholder:'Buscar'
     }"
   >
     <template slot="table-row" slot-scope="props">
          
    <span v-if="props.column.field == 'eliminar'">
       
       <b-button variant='danger'>Eliminar</b-button>
     
    </span>
    <span v-else>
      {{props.formattedRow[props.column.field]}}
    </span>
  </template>
   </vue-good-table>
</div>
      </b-card-text>

      <b-button variant="primary">Go somewhere</b-button>
    </b-card-body>
  </b-card>
</div>

    
  </div>
</template>

<script>
import Cabecera from './Cabecera' //v-on:keyup.enter="onEnter"
import Menu from './Menu'
import axios from 'axios'
import swal from 'sweetalert'
import sesion from '../mixins/sesion'

import eliminarDecomisos from '../mixins/eliminarDecomisos'
import {mapState, mapMutations, mapActions, mapGetters} from 'vuex'
export default {
  name: 'Decomisos',  
  data () {
    return {
        value:'1',
      msg: 'Número de arete',
      
      usuariolocal:'',
      fotolocal:'',
      unidad:'',
        fecha1:'',
        fecha2:'',
selected: null,
selected2: 'Bovino',
selectedOrgano:null,
selectedPadecimiento:null,
        options: [
            {
            label: '1. CANALES',
            options: [
              { value: {  organo: 'Canales',padecimiento:'Tuberculosis'  }, text: 'a) Tuberculosis' },
              { value: {  organo: 'Canales',padecimiento:'Toxemia'  }, text: 'b) Toxemia' },
              { value: {  organo: 'Canales',padecimiento:'Congestión'  }, text: 'c) Congestión' },
              { value: {  organo: 'Canales',padecimiento:'Caquexias'  }, text: 'd) Caquexias' },
              { value: {  organo: 'Canales',padecimiento:'Lisis'  }, text: 'e) Lisis' },
              { value: {  organo: 'Canales',padecimiento:'Otro'  }, text: 'f) Otro' },
            ]
          },
            {
            label: '2. CABEZAS',
            options: [
              { value: {  organo: 'Cabeza',padecimiento:'Abcesos'  }, text: 'a) Abcesos' },
              { value: {  organo: 'Cabeza',padecimiento:'Actinomicosis'  }, text: 'b) Actinomicosis' },
              { value: {  organo: 'Cabeza',padecimiento:'Actinobascilosis'  }, text: 'c) Actinobascilosis' },
              { value: {  organo: 'Cabeza',padecimiento:'Quistes paracitarios'  }, text: 'd) Quistes paracitarios' },
              { value: {  organo: 'Cabeza',padecimiento:'Epitelioma'  }, text: 'e) Epitelioma' },
              { value: {  organo: 'Cabeza',padecimiento:'Otro'  }, text: 'f) Otro' },
            ]
          },
          {
            label: '3. PULMONES',
            options: [
              { value: {  organo: 'Pulmones',padecimiento:'Neumonia'  }, text: 'a) Neumonia' },
              { value: {  organo: 'Pulmones',padecimiento:'Adherencias'  }, text: 'b) Adherencias' },
              { value: {  organo: 'Pulmones',padecimiento:'Nódulos hem'  }, text: 'c) Nódulos hem' },
              { value: {  organo: 'Pulmones',padecimiento:'Melanosis'  }, text: 'd) Melanosis' },
              { value: {  organo: 'Pulmones',padecimiento:'Neumonia purulenta'  }, text: 'e) Neumonia purulenta' },
              { value: {  organo: 'Pulmones',padecimiento:'Emfisema'  }, text: 'f) Emfisema' },
              { value: {  organo: 'Pulmones',padecimiento:'Abcesos'  }, text: 'g) Abcesos' },
              { value: {  organo: 'Pulmones',padecimiento:'Otro'  }, text: 'h) Otro' },
            ]
          },
          {
            label: '4. HÍGADO',
            options: [
              { value: {  organo: 'Hígado',padecimiento:'Abcesos'  }, text: 'a) Abcesos' },
              { value: {  organo: 'Hígado',padecimiento:'Parásitos'  }, text: 'b) Parásitos' },
              { value: {  organo: 'Hígado',padecimiento:'Otro'  }, text: 'c) Otro' },
              ]
          },
          {
            label: '5. VÍSCERAS TORÁCICAS',
            options: [
              { value: {  organo: 'Vísceras torácicas',padecimiento:'Abcesos'  }, text: 'a) Abcesos' },
              { value: {  organo: 'Vísceras torácicas',padecimiento:'Adherencias'  }, text: 'b) Adherencias' },
              { value: {  organo: 'Vísceras torácicas',padecimiento:'Pericarditis'  }, text: 'c) Pericarditis' },
              { value: {  organo: 'Vísceras torácicas',padecimiento:'Quistes parasitarios'  }, text: 'd) Quistes parasitarios' },
              { value: {  organo: 'Vísceras torácicas',padecimiento:'Neumonía purulenta'  }, text: 'e) Neumonía purulenta' },
              { value: {  organo: 'Vísceras torácicas',padecimiento:'Otro'  }, text: 'f) Otro' },
              ]
          },
          {
            label: '6. MENUDOS',
            options: [
              { value: {  organo: 'Menudos',padecimiento:'Abcesos'  }, text: 'a) Abcesos' },
              { value: {  organo: 'Menudos',padecimiento:'Adherencias'  }, text: 'b) Adherencias' },
              { value: {  organo: 'Menudos',padecimiento:'Congestión'  }, text: 'c) Congestión' },
              { value: {  organo: 'Menudos',padecimiento:'Edema'  }, text: 'd) Edema' },
              { value: {  organo: 'Menudos',padecimiento:'Otro'  }, text: 'e) Otro' },
              ]
          },
          {
            label: '7. INTESTINO DELGADO',
            options: [
              { value: {  organo: 'Intestino delgado',padecimiento:'Enteritis'  }, text: 'a) Enteritis' },
              { value: {  organo: 'Intestino delgado',padecimiento:'Quistes parasitarios'  }, text: 'b) Quistes parasitarios' },
              { value: {  organo: 'Intestino delgado',padecimiento:'Abcesos'  }, text: 'c) Abcesos' },
              { value: {  organo: 'Intestino delgado',padecimiento:'Congestión'  }, text: 'd) Congestión' },
              { value: {  organo: 'Intestino delgado',padecimiento:'Adherencias'  }, text: 'e) Adherencias' },
              { value: {  organo: 'Intestino delgado',padecimiento:'Otro'  }, text: 'f) Otro' },
              ]
          },
          {
            label: '8. INTESTINO GRUESO',
            options: [
              { value: {  organo: 'Intestino grueso',padecimiento:'Enteritis'  }, text: 'a) Enteritis' },
              { value: {  organo: 'Intestino grueso',padecimiento:'Quistes parasitarios'  }, text: 'b) Quistes parasitarios' },
              { value: {  organo: 'Intestino grueso',padecimiento:'Abcesos'  }, text: 'c) Abcesos' },
              { value: {  organo: 'Intestino grueso',padecimiento:'Congestión'  }, text: 'd) Congestión' },
              { value: {  organo: 'Intestino grueso',padecimiento:'Adherencias'  }, text: 'e) Adherencias' },
              { value: {  organo: 'Intestino grueso',padecimiento:'Otro'  }, text: 'f) Otro' },
              ]
          },
          {
            label: '9. RIÑONES',
            options: [
              { value: {  organo: 'Riñones',padecimiento:'Hidronefritis'  }, text: 'a) Hidronefritis' },
              { value: {  organo: 'Riñones',padecimiento:'Nefrosis'  }, text: 'b) Nefrosis' },
              { value: {  organo: 'Riñones',padecimiento:'Otro'  }, text: 'c) Otro' },
              ]
          },
          {
            label: '10. RIÑONES',
            options: [
              { value: {  organo: 'Riñones',padecimiento:'Hidronefritis'  }, text: 'a) Hidronefritis' },
              { value: {  organo: 'Riñones',padecimiento:'Nefrosis'  }, text: 'b) Nefrosis' },
              { value: {  organo: 'Riñones',padecimiento:'Otro'  }, text: 'c) Otro' },
              ]
          },
          {
            label: '11. PATAS',
            options: [
              { value: {  organo: 'Patas',padecimiento:'Fracturas'  }, text: 'a) Fracturas' },
              { value: {  organo: 'Patas',padecimiento:'Inflamación'  }, text: 'b) Inflamación' },
              { value: {  organo: 'Patas',padecimiento:'Otro'  }, text: 'c) Otro' },
              ]
          },
          {
            label: '12. CUAJO',
            options: [
              { value: {  organo: 'Cuajo',padecimiento:'Congestión'  }, text: 'a) Congestión' },
              { value: {  organo: 'Cuajo',padecimiento:'Otro'  }, text: 'b) Otro' },
            ]
          },
          {
            label: '13. RECTO',
            options: [
              { value: {  organo: 'Recto',padecimiento:'Congestión'  }, text: 'a) Congestión' },
              { value: {  organo: 'Recto',padecimiento:'Otro'  }, text: 'b) Otro' },
            ]
          },
        ],

      columns:[
        {
          label:'Serie',
          field:'serie'
        },
        {
          label:'Folio',
          field:'canal'
        },
        {
          label:'Fecha',
          field:'fecha',
          type:'date',
          dateInputFormat:'yyyy-mm-dd',
          dateOutputFormat:'yyyy-mm-dd'
        },
        {
          label:'Órgano',
          field:'partedecomisada'
        },
        {
          label:'Diagnóstico',
          field:'diagnostico'
        },
        {
          label:'Folio decomiso',
          field:'foliodecomiso'
        },
        {
          label:'Eliminar',
          field:'eliminar'
        },
      ],
      rows:[

      ]
    }
    },
  
  computed:{
      ...mapState(['usuarioActual','idActual','fotoActual'])
  },
  methods:{
      getStringDatos(){
     this.selectedPadecimiento=this.selected.padecimiento   
   this.selectedOrgano=this.selected.organo
    
      },
      
    getId(){
           this.usuario()

            const id = document.getElementById("usuarioForma").value
            
            axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getPerfilUsuario.php?id='+ id)
            
                .then(response=>{
                   
                    this.unidad = response.data.unidad
                    this.usuariolocal=response.data.email
                    
                })
                   
        },

     onCellClick(params) {
         if(params.column.field=="eliminar"){
         this.eliminarDecomisos(params.row.id)
         this.ajax()
         }
        this.ajax()
         //
   // alert (params.row.id) // params.row - row object   /// 
    // params.pageIndex - index of this row on the current page.
    // params.selected - if selection is enabled this argument 
    // indicates selected or not
    // params.event - click event
  },
      /*onEnter: function() {
      swal("Mensaje de enter")
    },*/
    fecha(){
        var dt = new Date();
    document.getElementById("datetime").innerHTML = ((dt.getFullYear() +"-"+ (("0"+(dt.getMonth()+1)).slice(-2)) 
    +"-"+ ("0"+dt.getDate()).slice(-2)));
    },
    ajax(){
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     this.getId()
     const fecha = document.getElementById("fechadia").value
     const unidadquery=this.unidad
     const especiequery=this.selected2
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getdecomisosbovinos.php?fecha='+fecha+'&unidad='+unidadquery+'&especie='+especiequery)
      .then(response=>{
        this.rows=response.data
      })

    },
    usuario(){
        this.fecha()
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     var yourString = this.$localStorage.get('token');
     var result = yourString.slice(1,-1);
     //this.usuariolocal= result
     //const tok=this.usuariolocal
     const tok=result
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getUserData2.php?token='+tok)
      .then(response=>{
       
        this.usuariolocal=response.data.email
        this.unidad=response.data.unidad
        this.perfil=response.data.perfil
      })

    },
    ticketIncremento(){
       // document.getElementById('canal').value=document.getElementById('canal').value++
    this.value=Number(this.value)+1
    },
    editar(){
            this.getStringDatos()
            this.usuario()
            
             const form=document.getElementById('formPeso')
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/registrarDecomisos.php',new FormData(form))
                .then(res=>{
                    this.respuesta = res.data
                    if (res.data == 'success') {
                        this.ticketIncremento()
                      
                       swal('Se registro el decomiso con éxito')
                       //location.reload()
                        //this.$router.push('/inicio')
                        
                    } else {
                        swal('El decomiso no pudo ser registrado'+res.data)
                    }
                })
        },
        direccionamiento(){
            if (this.respuesta=='success') {
                this.$router.push('/')
            } else {
                swal({
                    title:'No se pudo registrar',
                    icon: 'error'})  
            }
        },
  },
  created(){
    this.ajax()
    this.usuario()

  },
  components:{
    Cabecera,
    Menu
  },
  mixins:[sesion,eliminarDecomisos]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->




// WEBPACK FOOTER //
// src/components/Decomisos.vue